module.exports = __webpack_public_path__ + "media/images/avatar-1f8c387973cab7b0130fcfb78009ecc8.png";